import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';

import Title from '../Title';
import Input from '../Input';
import Spinner from '../Spinner';
import AlertMessage from '../AlertMessage';
import Button from '../Button';
import { showAlert } from '../../app/actions/uiActions';
import { createStripeAccount } from '../../app/actions/stripeActions';

import './styles.scss';

const SubscriptionForm = ({activeSubscription}) => {
  const dispatch = useDispatch();
  const ui = useSelector((state) => state.ui);

  const [form, setForm] = useState({
    number: "",
    month: null,
    year: null,
    cvv: "",
    cardholderName: "",
  } )

  const handleChangeInput  = (target,expiration) => {

    if(target.id === 'number' || target.id === 'cvv') {
      const spData = target.value.split("");
      setForm((prev) => ({...prev, [target.id]: spData}))
    }

    if(target.id === 'cardholderName' ) {
      setForm((prev) => ({...prev, [target.id]: target.value}))
    }

    if(target.id === 'expiration') {

      if(expiration) {
        const date = target.value.split("")
        if(!isNaN(Number(date[3])) && !isNaN(Number(date[4]))) {
          const currentYear = "20" + date[3] + date[4];
          const currentData = currentYear + date[0] + date[1];
          const currentDay = moment(currentData,"YYYYMM").endOf("month").format("DD");
          const resData = moment(`${currentData}${currentDay}`,"YYYYMMDD").diff(moment(new Date()), 'months', true)

          if(resData >= 0) {
            const month = Number(`${date[0]}${date[1]}`);
            const year = Number(currentYear);

            setForm(prev => ({...prev,month,year}))

          } else {
            dispatch(showAlert({type: 'error', message: 'Invalid expiration field'}));
            setForm(prev => ({...prev,month: null}))
          }

        } else {
          setForm(prev => ({...prev,month: null}))
        }
        
      } else {
        setForm(prev => ({...prev,month: null}))
      }
    }
  };
  
  const handleSubmitPatient = (event) => {
    event.preventDefault();
    const data = {
      card: {}
    };

    if(form.number){

      const newData = form.number.map(el => Number(el))
      const result  = newData.filter(el => isNaN(el))

      if(newData[0] === 0) {
        dispatch(showAlert({type: 'error', message: 'Invalid card number field'}));
        return
      }
      
      if(result.length !== 0) {
        dispatch(showAlert({type: 'error', message: 'Invalid card number field'}));
        return
      } 
      
      const newNumber = newData.filter((el,i) => (++i) % 5 !== 0).join('');
      data.card.number = newNumber;
      
    } else {
      dispatch(showAlert({type: 'error', message: 'Invalid card number field'}));
      return 
    }
    
    if(form.month && form.year) {
      data.card.month = form.month;
      data.card.year = form.year;
    } else {
      dispatch(showAlert({type: 'error', message: 'Invalid expiration field'}));
      return
    }
    
    if(form.cvv) {
      const newData = form.cvv.map(el => Number(el))
      const result  = newData.filter(el => isNaN(el))
      
      if(!newData.length) {
        dispatch(showAlert({type: 'error', message: 'Invalid cvv field'}));
        return
      } 
      
      if(result.length !== 0) {
        dispatch(showAlert({type: 'error', message: 'Invalid cvv field'}));
        return
      }
      
      const cvc = form.cvv.join('');
      data.card.cvc = cvc;
      
    } else {
      dispatch(showAlert({type: 'error', message: 'Invalid cvv field'}));
      return
    }
    
    if(form.cardholderName) {
      data.card.name = form.cardholderName;
    } else {
      dispatch(showAlert({type: 'error', message: 'Invalid name field'}));
      return
    }
    
    const result = currentPlan();
    
    if(!result.length) {
      dispatch(showAlert({type: 'error', message: 'Choose the current plan'}));
      return
    }

    data.plan = result[0];

    dispatch(createStripeAccount(data));
	
  };

  const currentPlan = () => {
    const dataubscription = Object.keys(activeSubscription);
    const result = dataubscription.filter(el => activeSubscription[el] === true);
    return result;
  };

  return (
    <div className="subscription__form">
      <Title text="Free Limit Reached" isBig isWhite isBold isTexStart/>
      <form onSubmit={handleSubmitPatient}>
        <Input 
          value={form.number}
          id='number'
          type='text' 
          label='Card Number'
          isCard
          isPlaceholder
          mask="9999 9999 9999 9999"
          placeholder="1345 2367 8845 7365"
          onChange={handleChangeInput}
        />
        <div className="virus__row">
          <div className="virus__col virus__col--margin-right">
            <Input 
              value={form.doctorName}
              id='expiration'
              type='text' 
              label='Expiration'
              isCard
              isPlaceholder
              mask="99/99"
              placeholder="07/22"
              onChange={handleChangeInput}
            />
          </div>
          <div className="virus__col">
            <Input 
              value={form.cvv}
              id='cvv'
              type='text' 
              label='CVV'
              isCard
              isPlaceholder
              mask="999"
              placeholder="555"
              onChange={handleChangeInput}
            />
          </div>
        </div>
        <Input 
          value={form.cardholderName}
          id='cardholderName'
          type='text' 
          label='Cardholder Name'
          placeholder="Kimberly Thompson"
          isPlaceholder
          onChange={handleChangeInput}
        />
        <AlertMessage showAlert={ui.showAlert}/>
        <div className="virus__btn">
          <Button text='Sign Up'/>
        </div>
      </form>
      {ui.isLoadSpinner && (
        <div className="subscription__spin-wrap">
          <Spinner />
        </div>
      )}
    </div>
  );
};

export default SubscriptionForm;
